import type { AiMessage } from 'juneau';

/**
 * True for an assistant message with nothing to show — the placeholder juneau adds
 * before a greeting streams, left empty when the server answers with `done` alone.
 */
export function isEmptyAssistantMessage(message: Pick<AiMessage, 'role' | 'parts'>): boolean {
  return (
    message.role === 'assistant' &&
    message.parts.every(
      part => part.type === 'text' && typeof part.text === 'string' && part.text.trim() === ''
    )
  );
}
